import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { inputClasses } from "./input";

export function Textarea({ className, variant = "default", ...props }: ComponentProps<"textarea"> & { variant?: "default" | "composer" }) {
  return <textarea data-slot="textarea" className={cn(inputClasses, "min-h-24 resize-y leading-relaxed", variant === "composer" && "resize-none rounded-none border-0 bg-transparent px-1 shadow-none focus-visible:border-transparent focus-visible:ring-0", className)} {...props} />;
}
